import { TooltipProps } from '@ubnt/ui-components/Tooltip/Tooltip';
import { memo } from 'react';

import { Flex } from 'components/Flex';
import ButtonPickerButton, { ButtonPickerButtonProps } from './ButtonPickerButton';

interface ButtonPickerOption extends ButtonPickerButtonProps {
  value: string;
}

export interface ButtonPickerProps {
  isDisabled?: boolean;
  onChange?: (newValue: string) => void;
  options: ButtonPickerOption[];
  tooltipDescription?: TooltipProps['description'];
  value: string | null;
}

const ButtonPicker = (props: ButtonPickerProps) => {
  const { isDisabled: isDisabledProp, onChange, options, tooltipDescription: tooltipDescriptionProp, value } = props;

  return (
    <Flex gap="xs">
      {options.map((option) => {
        const {
          value: optionValue,
          isDisabled: isDisabledOption,
          tooltipDescription: tooltipDescriptionOption,
          ...rest
        } = option;
        const isDisabled = !!isDisabledProp || !!isDisabledOption;
        const isSelected = value === optionValue;
        const onClick = isDisabled ? undefined : () => onChange?.(optionValue);
        const tooltipDescription = tooltipDescriptionProp ? undefined : tooltipDescriptionOption;
        return (
          <ButtonPickerButton
            data-value={optionValue}
            isDisabled={isDisabled}
            isSelected={isSelected}
            key={optionValue}
            onClick={onClick}
            tooltipDescription={tooltipDescription}
            {...rest}
          />
        );
      })}
    </Flex>
  );
};

const MemoizedButtonPicker = memo(ButtonPicker);

export default MemoizedButtonPicker;
